import React from "react";

const UserIcon = (props) => (
  <svg
    width="29"
    height="33"
    viewBox="0 0 29 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.5"
      d="M24.1107 32.9141H0.0859375V26.3045C0.0931896 24.7139 0.73014 23.191 1.85745 22.0688C2.98476 20.9466 4.51066 20.3166 6.10129 20.3167H18.1137C18.9024 20.3167 19.6834 20.472 20.4122 20.7739C21.1409 21.0757 21.803 21.5181 22.3607 22.0758C22.9184 22.6336 23.3608 23.2957 23.6627 24.0244C23.9645 24.7531 24.1199 25.5341 24.1199 26.3228L24.1107 32.9141Z"
      fill="#FEB348"
    />
    <path
      d="M27.7675 29.2574H3.74268V22.6478C3.74993 21.0572 4.38688 19.5342 5.51419 18.4121C6.6415 17.2899 8.1674 16.6599 9.75803 16.6599H21.7704C23.3634 16.6599 24.8911 17.2927 26.0174 18.4191C27.1438 19.5455 27.7766 21.0732 27.7766 22.6661L27.7675 29.2574Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.7548 1.91431C16.883 1.91431 17.9859 2.24888 18.924 2.8757C19.8621 3.50252 20.5933 4.39343 21.0251 5.43579C21.4568 6.47816 21.5698 7.62518 21.3497 8.73174C21.1296 9.83831 20.5863 10.8547 19.7885 11.6525C18.9907 12.4503 17.9742 12.9936 16.8677 13.2137C15.7611 13.4338 14.6141 13.3209 13.5718 12.8891C12.5294 12.4573 11.6385 11.7262 11.0117 10.7881C10.3849 9.85 10.0503 8.74705 10.0503 7.61881C10.0527 6.10662 10.6545 4.65706 11.7238 3.58778C12.793 2.5185 14.2426 1.91672 15.7548 1.91431Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserIcon;
